import { render, staticRenderFns } from "./OptionReadonly.vue?vue&type=template&id=03be6bc3&"
import script from "./OptionReadonly.vue?vue&type=script&lang=js&"
export * from "./OptionReadonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports